import React from 'react';
import { Typography } from '@material-ui/core';
import styled from 'styled-components';
import parse from 'html-react-parser';
import { Icons } from '../../components';

const StyledWrap = styled.div`
  display: flex;
  justify-content: center;
`;

const StyledWrapContent = styled.div`
  width: 100%;
  max-width: 900px;
  display: flex;
  flex-direction: column;
`;

const StyledHeader = styled.div`
  display: flex;
  padding: 16px;
  border-bottom: 1px solid #d4d4d4;
`;

const StyledIcon = styled.div`
  cursor: pointer;
  padding-top: 5px;
`;

const StyledTitle = styled.div`
  margin-left: 24px;
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const StyledBody = styled.div`
  padding-bottom: 32px;
  border-bottom: 1px solid #d4d4d4;
`;

const DetailLain = ({ isId, onHandleBack, dataPbdj }: any) => {
  const { sub_title_id, sub_title_en, place, content_id, content_en } =
    dataPbdj;

  return (
    <StyledWrap>
      <StyledWrapContent>
        <StyledHeader>
          <StyledIcon onClick={onHandleBack}>
            <Icons.IconBack height={25} width={25} />
          </StyledIcon>
          <StyledTitle>
            <Typography variant='h5' color='primary'>
              {isId ? sub_title_id : sub_title_en}
            </Typography>
            <Typography color='textPrimary'>{place}</Typography>
          </StyledTitle>
        </StyledHeader>
        <StyledBody>
          <div id='content' style={{ marginTop: '2rem' }}>
            {parse(isId ? content_id : content_en)}
          </div>
        </StyledBody>
      </StyledWrapContent>
    </StyledWrap>
  );
};

export default DetailLain;
